module.exports = __webpack_public_path__ + "static/media/_qOt4ius.3946f647.png";